import React from 'react';
import { useGetTagsQuery } from '../../Tags/Service/tagsApi';
import type { Tag } from '../../Tags/Types/tagsType';
import {
  mapTagToExpenseInvoiceLookup,
  type ExpenseInvoiceTagLookup,
} from './expenseInvoiceTagsLookupMapper';

type TagsQueryOptions = Parameters<typeof useGetTagsQuery>[1];
type TagsQueryResult = ReturnType<typeof useGetTagsQuery>;

type ExpenseInvoiceTagsLookupQueryResult = Pick<
  TagsQueryResult,
  'isLoading' | 'isFetching' | 'isError' | 'error' | 'refetch'
> & {
  data: ExpenseInvoiceTagLookup[];
};

export const useGetExpenseInvoiceTagsLookupQuery = (
  options?: TagsQueryOptions
): ExpenseInvoiceTagsLookupQueryResult => {
  const queryResult = useGetTagsQuery(undefined, options);

  const data = React.useMemo(
    () =>
      (queryResult.data ?? [])
        .map((tag: Tag) => mapTagToExpenseInvoiceLookup(tag))
        .filter(
          (tag: ExpenseInvoiceTagLookup | undefined): tag is ExpenseInvoiceTagLookup => Boolean(tag)
        ),
    [queryResult.data]
  );

  return {
    data,
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    isError: queryResult.isError,
    error: queryResult.error,
    refetch: queryResult.refetch,
  };
};
